export const GoldRule = ({ size = 'short', className = '' }) => {
  const width =
    size === 'med'
      ? 'w-[160px]'
      : size === 'long'
      ? 'w-[260px]'
      : 'w-[88px]';
  return (
    <span
      className={`block bg-gold ${width} ${className}`}
      style={{ height: '0.5px' }}
      aria-hidden="true"
    />
  );
};

export default GoldRule;
